export enum TypeBienEnum {
  MAISON = "M",
  APPARTEMENT = "A",
  GARAGE = "BG",
  LOCAL_COMMERCIAL = "LC",
}

export type TypeBien = TypeBienEnum | null;
